var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-toast',{attrs:{"id":"my-toast","variant":"primary","auto-hide-delay":"5000","solid":""},on:{"click":function($event){return _vm.hideToast()}}},[_vm._v(" "+_vm._s(_vm.toastMsg)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }